var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import ReactMapboxGl, { Layer, Feature } from 'react-mapbox-gl';
import { validateAddress } from '@debbie/common/dist';
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZWJyYW5kdCIsImEiOiJjazNpc3Z3bmIwYXk2M2NsYzh6cTliNTJiIn0.1co_3bHhPMh8Ruv2LrwIrg';
const TheMap = ReactMapboxGl({
    accessToken: MAPBOX_ACCESS_TOKEN,
});
const Map = (props) => {
    const [state, setState] = useState({
        longitude: props.longitude || null,
        latitude: props.latitude || null,
    });
    const zoom = [15];
    const bearing = [0];
    const pitch = [30];
    useEffect(() => {
        setupMap();
    }, []);
    const setupMap = () => __awaiter(void 0, void 0, void 0, function* () {
        if (state.longitude && state.latitude) {
            return;
        }
        const { address, zipcode, city, country } = props.address;
        if (!validateAddress(props.address))
            return;
        const res = yield fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}, ${zipcode} ${city}, ${country || 'Denmark'}.json?access_token=${MAPBOX_ACCESS_TOKEN}`);
        const geocode = yield res.json();
        if (geocode.features[0]) {
            setState({
                longitude: geocode.features[0].center[0],
                latitude: geocode.features[0].center[1],
            });
        }
    });
    return (React.createElement("div", { style: {
            position: 'relative',
            height: props.height || '100vh',
            width: props.width || '100%',
        } },
        React.createElement("style", null, `
          .mapbox-wrapper canvas {
            height: ${props.height || '100vh'} !important;
            width: ${props.width || '100%'} !important;
          }
        `),
        state.latitude && state.longitude && (React.createElement(TheMap, { style: "mapbox://styles/mapbox/streets-v10", containerStyle: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: '100%',
                height: '100%',
                borderRadius: '3px',
            }, onStyleLoad: (map) => map.resize(), zoom: zoom, center: [state.longitude, state.latitude], pitch: pitch, bearing: bearing },
            React.createElement(Layer, { id: "3d-buildings", sourceId: "composite", sourceLayer: "building", filter: ['==', 'extrude', 'true'], type: "fill-extrusion", minZoom: 14, paint: {
                    'fill-extrusion-color': '#aaa',
                    'fill-extrusion-height': {
                        type: 'identity',
                        property: 'height',
                    },
                    'fill-extrusion-base': {
                        type: 'identity',
                        property: 'min_height',
                    },
                    'fill-extrusion-opacity': 0.6,
                } }),
            React.createElement(Layer, { type: "symbol", layout: { 'icon-image': 'circle-15' } },
                React.createElement(Feature, { coordinates: [state.longitude, state.latitude] }))))));
};
export default Map;
//# sourceMappingURL=Map.js.map